import { getSVG } from './components/icons-loader.js';
import { showMoreFaqs, accordion } from './components/accordion.js';
import { videoLazyLoading } from './components/video.js'

document.addEventListener("DOMContentLoaded", function () {
  accordion('.faqs-cards');
  showMoreFaqs();
  getSVG();
  videoLazyLoading();
});
